import { stringify } from 'query-string';
import { fetchJSON } from '@catalogo/core-http';

export default config => async (_, args) => {
  const { filler } = config.endpoints;
  const { cartId, products } = args;
  const data = JSON.stringify({ cart: { id: cartId }, products });
  const fillerUrl = `${filler}?${stringify({ redirect: false, data })}`;
  const { id, ...rest } = await fetchJSON(fillerUrl);

  return {
    cartId: id,
    ...rest,
  };
};
